import { render, staticRenderFns } from "./TabPaneRca.vue?vue&type=template&id=4a9196d2&scoped=true"
import script from "./TabPaneRca.vue?vue&type=script&lang=js"
export * from "./TabPaneRca.vue?vue&type=script&lang=js"
import style0 from "./TabPaneRca.vue?vue&type=style&index=0&id=4a9196d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9196d2",
  null
  
)

export default component.exports